import React from 'react';
import {
  clone,
  forEach,
} from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core';
import { editTags } from '@pingum/app-state-management/tag/actions';
import {
  updateTagInTagsHierarchicalList,
  searchForTagInHierarchicalList,
} from '../../../../../utils/tagHelper';

const addTagAndChildrenToList = (tagsToUpdate, tag) => {
  tagsToUpdate.push({
    tagId: tag.id,
    archived: true,
  });
  if (tag.children && tag.children.length > 0) {
    forEach(tag.children, (childTag) => {
      addTagAndChildrenToList(tagsToUpdate, childTag);
    });
  }
};

const removeTagChildrenOnMove = (updatedTagList, tagToUpdate) => {
  const newTagToUpdate = tagToUpdate;
  newTagToUpdate.children = []; // remove children
  updateTagInTagsHierarchicalList(updatedTagList, newTagToUpdate, false);
};

export const addTagChildrenToTagParent = (updatedTagList, tagToUpdate, originalTag) => {
  // search for parent tag to get full object
  const parentTag = searchForTagInHierarchicalList(
    {
      id: -1,
      children: updatedTagList,
    },
    tagToUpdate.parentTag.id,
  );
  if (parentTag) {
    if (!parentTag.children) {
      parentTag.children = [];
    }
    parentTag.children
      = parentTag.children.concat(originalTag.children
        ? originalTag.children
        : []);
  }
  updateTagInTagsHierarchicalList(updatedTagList, parentTag, false);
};

const buildTagListForUpdates = (tag) => {
  const tagsToUpdate = [];
  // archive the tag being archived
  tagsToUpdate.push({
    tagId: tag.id,
    archived: true,
  });
  // update first level to children tags to have new parent
  forEach(tag.children, (childTag) => {
    if (tag.parentTag && tag.parentTag.id) {
      // move to current parents parent
      tagsToUpdate.push({
        tagId: childTag.id,
        parentTagId: tag.parentTag.id,
      });
    } else {
      // move to the root
      tagsToUpdate.push({
        tagId: childTag.id,
        customActions: { removeParentTag: true },
      });
    }
  });
  return tagsToUpdate;
};

export class MoveOrArchiveChildrenTagsModalComponent extends React.Component {
  handleMoveConfirm = () => {
    const tagToUpdate = clone(this.props.tag, true);
    let updatedTagList = clone(this.props.tags, true);

    // remove all children from tag
    removeTagChildrenOnMove(updatedTagList, tagToUpdate);

    // update the children tag of this tag
    if (tagToUpdate.parentTag) {
      // tag has a parent so we need to find parent and add children to it
      addTagChildrenToTagParent(updatedTagList, tagToUpdate, this.props.tag);
    } else {
      // tag is root so lets update children to the root as well
      updatedTagList = updatedTagList.concat(this.props.tag.children);
    }
    // update redux state to the UI can reflect DB changes
    this.props.onTagListUpdate(updatedTagList);

    // build tag list to send to API for updates
    const tagsToUpdate = buildTagListForUpdates(this.props.tag);

    this.props.editTags(tagsToUpdate);
    this.props.handleCloseModal();
  }

  handleArchiveConfirm = () => {
    const tagsToUpdate = [];
    // archive the tag being archived
    tagsToUpdate.push({
      tagId: this.props.tag.id,
      archived: true,
    });
    // update all tags in children tree to be archived
    if (this.props.tag.children) {
      forEach(this.props.tag.children, (childTag) => {
        addTagAndChildrenToList(tagsToUpdate, childTag);
      });
    }

    this.props.editTags(tagsToUpdate);
    this.props.handleCloseModal();
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.props.isOpen}
          onClose={this.props.handleCloseModal}
          aria-labelledby="edit-tag-title"
          aria-describedby="edit-tag-description"
          id="edit-tag-dialog"
        >
          <DialogTitle id="edit-tag-title">This Tag Has Children</DialogTitle>
          <DialogContent>
            <DialogContentText id="remove-tag-description">
              What would you like to do about the children Tags?
              <br /><br />

              <b>Archiving Children </b>
              Tags will archive all child tags in the hierarchy.

              <br />
              <b>Moving Children </b> Tags moves all children Tags up a level in the hierarchy.

            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.props.handleCloseModal}
              id="cancel-archive-move-button"
            >
              Cancel
            </Button>
            <Button
              onClick={() => { this.handleArchiveConfirm(); }}
              color="primary"
              autoFocus
              id="confirm-archive-button"
            >
              Archive Children
            </Button>
            <Button
              onClick={() => { this.handleMoveConfirm(); }}
              color="primary"
              autoFocus
              id="confirm-move-button"
            >
              Move Children
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

MoveOrArchiveChildrenTagsModalComponent.propTypes = {
  onTagListUpdate: PropTypes.func,
  tag: PropTypes.object,
  tags: PropTypes.array,
  isOpen: PropTypes.bool,
  handleCloseModal: PropTypes.func,
  editTags: PropTypes.func,
};

MoveOrArchiveChildrenTagsModalComponent.defaultProps = {
  onTagListUpdate: () => {},
  tag: {},
  tags: [],
  isOpen: false,
  handleCloseModal: () => { },
  editTags: () => {},
};

export const mapDispatchToProps = (dispatch) => ({ editTags: (request) => dispatch(editTags(request)) });

export default connect(
  null,
  mapDispatchToProps,
)(MoveOrArchiveChildrenTagsModalComponent);
